export const config = {
  NASA_API_KEY: 'x1cmS82wFKgE82gedgVCwzJEng06s29yzTkdovS4',
}
